import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import BusinessMpProvider from "@/core/data-provider/data-mp/business/business-mp-provider";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { setPcInfo } from "@/domains/business/slice";
import toast from "@/domains/toasts/helpers/toast";

export default function useGetPcInfo(businessId: number) {
  const { t, i18n } = useTranslation("business");
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const load = useCallback(async () => {
    if (businessId) {
      setIsLoading(true);

      try {
        const response = await BusinessMpProvider.getInfo(businessId);

        if (response instanceof RpcMpProviderSuccessResponse) {
          dispatch(setPcInfo(response.data));
        } else if (i18n.exists(`business:business.errors.${response.error.message}`)) {
          console.error(response.error.message);
          toast.error(t(`business.errors.${response.error.message}`));
        } else {
          console.error(response.error.message);
          toast.error(t("business.toast.infoLoadError"));
        }
      } catch (e) {
        console.error(e);
        toast.error(t("business.toast.infoLoadError"));
      } finally {
        setIsLoading(false);
      }
    }
  }, [businessId, i18n, dispatch, t]);

  useEffect(() => {
    if (businessId) load();
  }, [businessId, load]);

  return { isLoading };
}
